/**
 * The console feature's HTTP helpers.
 *
 * Requests go through the shared `fetchClient` — base URL, API key, cookie and
 * token refresh live there. What stays here is what every console endpoint
 * needs on top of it: the gateway envelope unwrapped the same way, and one
 * error type the mutation feedback knows how to read.
 */

export interface GatewayEnvelope<T> {
  statusCode?: number;
  message?: string;
  item?: T;
}

export class MonitoringApiError extends Error {
  status: number;
  body?: unknown;

  constructor(message: string, status: number, body?: unknown) {
    super(message);
    this.name = 'MonitoringApiError';
    this.status = status;
    this.body = body;
  }
}

/** A failed gateway answer, raised as the console's error. */
export function toMonitoringApiError(
  path: string,
  response: Response,
  body: unknown,
): MonitoringApiError {
  return new MonitoringApiError(
    `Monitoring API ${response.status} for ${path}`,
    response.status,
    body,
  );
}

/** The record inside a gateway envelope, or the body when it carries none. */
export function unwrap<T>(body: unknown): T | undefined {
  if (body !== null && typeof body === 'object' && 'item' in body) {
    return (body as GatewayEnvelope<T>).item;
  }

  return body as T | undefined;
}
